import { ArrowRight } from 'lucide-react';
import YouTubeFacade from './YouTubeFacade';
import TestimonialsCompact from './TestimonialsCompact';

export default function HeroMinimal() {
  return (
    <section className="min-h-screen flex items-center justify-center px-4 sm:px-6 pt-24 sm:pt-28 pb-12 bg-white">
      <div className="max-w-5xl mx-auto w-full">

        {/* Hero headline */}
        <div className="mb-8 md:mb-12 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6 leading-tight tracking-tight">
            Convertite en el experto en datos del equipo de RR.HH.
          </h1>

          {/* Program highlight - protagonist */}
          <div className="mb-6 flex justify-center">
            <div className="relative inline-block px-8 py-5 sm:px-10 sm:py-6 rounded-2xl border-2 border-[#C5075D]/30 bg-gradient-to-br from-[#C5075D]/5 via-white to-[#C5075D]/5 shadow-lg shadow-[#C5075D]/10">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full shadow-lg text-white text-[10px] sm:text-xs font-bold uppercase tracking-wide bg-gradient-to-r from-[#C5075D] to-[#A00550]">
                <span>✦</span>
                <span>Incluye IA</span>
              </div>
              <strong className="font-extrabold text-2xl sm:text-3xl md:text-4xl lg:text-5xl block text-center bg-gradient-to-r from-[#C5075D] to-[#A00550] bg-clip-text text-transparent leading-tight md:leading-[1.2] lg:leading-[1.25] md:pb-1 lg:pb-1.5">
                Programa de Datos e IA para RR.HH.
              </strong>
              <p className="text-neutral-600 text-sm sm:text-base mt-2 text-center">
                Para profesionales de RR.HH. que usan datos en su trabajo, sin ser expertos.
              </p>
            </div>
          </div>

          <div className="flex justify-center">
            <a
              href="#programa-section"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#C5075D] to-[#A00550] hover:opacity-90 text-white rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 hover:shadow-xl hover:scale-105"
            >
              <span>Conocer más sobre el programa</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Two-column layout */}
        <div className="flex flex-col sm:grid sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-12 sm:items-center">

          <div className="order-2 sm:order-none sm:col-span-1 flex justify-center">
            <div
              className="relative bg-black rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl border-2 border-neutral-200 w-1/2 sm:w-full"
              style={{ aspectRatio: '9/16' }}
            >
              <YouTubeFacade
                videoId="rPp95NDNwdY"
                title="Cómo trabajar con datos con seguridad y confianza"
              />
            </div>
          </div>

          <div className="order-3 sm:order-none sm:col-span-2">
            {/* Compact testimonials — fills the space right of the video on desktop */}
            <div className="hidden sm:block">
              <TestimonialsCompact />
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
